import { styled, SxProps, Theme } from '@mui/material/styles';
export type LogoProps = {
  image?: string;
  alt?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

const Logo = (props: LogoProps) => {
  const { image } = props;

  return (<Img alt={props?.alt} src={image} sx={props.sx} {...props} />) as React.ReactElement;
};

const Img = styled('img')(({ theme }) => ({}));

export default Logo;
export { Logo };
